import React, { useState, useEffect } from 'react';
import { useScript } from 'react-apple-signin-auth';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import './AutoBidModal.css'; // Custom styles
import { editAutoBidAmount } from "@/api/bids";
import LoadingText from "@/components/loader/LoadingText";
import LoadedText from "@/components/loader/LoadedText";
import {
    getBidAmountDetail,
    getBuyersPremiumDetail,
} from "@/api/bidDepositApiHold";

import { toast } from "react-toastify";
const AutoBidModal = ({ show, handleClose, autoBidData, bidAmount, autoBidAmountFormatted, bidId, listingId, propertyCategory }) => {



    const [autoBidAmount, setAutoBidAmount] = useState(autoBidData?.bidAmountDetail?.bidAmount);
    const [autoBidValidationError, setAutoBidValidationError] = useState();
    const [isLoading, setIsLoading] = useState();
    const [buyerFeeFormatted, setBuyerFeeFormatted] = useState(null);
    const [buyerPremiumPercent, setBuyerPremiumPercent] = useState();

    const shouldShowBuyerPremium = (autoBidData?.bidAmountDetail?.premiumPaidBy === 'BUYER' || autoBidData?.bidAmountDetail?.buyerPremium !== null) ? true : false

    const nextPossibleBidAmount = autoBidData?.bidAmountDetail?.nextpossibleBidAmount ? autoBidData?.bidAmountDetail?.nextpossibleBidAmount : autoBidData?.bidAmountDetail?.nextPossibleBidAmountPostReserve

    console.log('autoBidData?.bidAmountDetail?.premiumPaidBy', autoBidData?.bidAmountDetail);
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    };

    useEffect(() => {
        getAmountDetailsData(autoBidData?.bidAmountDetail?.bidAmount);
    }, [bidId]);

    const handleAutoBidSave = async () => {

        validateAutobidAmount();
        if (!autoBidValidationError && autoBidValidationError?.length === 0) {
            setIsLoading(true);
            const payload = {
                autoBidAmount: autoBidAmount,
                incrementMultiplierAmount: autoBidData?.minimumBidIncrement,
                bidId: bidId,
                listingId: listingId,
            }
            const data = await editAutoBidAmount(payload);
            console.log('data ->', data)
            if (data.response === "SUCCESS") {
                toast.success("Your auto bid details saved successfully")


                setIsLoading(false);
                handleClose();

            } else {
                setIsLoading(false);

            }
        }

    }


    const cleanAmount = (amountString) => {
        const str = amountString.toString();
        return str?.replace(/[$,]/g, '');
    };
    const currencyFormatNew = (num) => {
        return num?.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };


    const getFormatPrice = amount => {

        if (amount?.length === 0 || isNaN(amount)) {
            return "";
        }
        return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };


    // useEffect(() => {
    //     console.log('autoBidAmountFormatted ->', autoBidAmountFormatted)
    //         setAutoBidAmount(autoBidAmountFormatted);

    //     }, [autoBidAmountFormatted]);

    const handleDecrement = () => {
        console.log('handleDecrement -> ', autoBidData)

        setAutoBidValidationError("");
        if (autoBidAmount > autoBidData?.bidAmountDetail?.bidAmount) {
            const newAmnt = parseFloat(cleanAmount(autoBidAmount)) - autoBidData?.minimumBidIncrement;
            setAutoBidAmount(newAmnt);
            validateAutobidAmount(newAmnt);

        }
    };

    const isValidIncrement = (base, value) => {
        return (value - base) % 1000 === 0;
    }

    console.log('autoBidData', autoBidData);
    // const validateAutobidAmount = (autobidAmnt) => {
    //     const amnt = autobidAmnt ? autobidAmnt : autoBidLimit;

    //     if (cleanAmount(amnt) > autoBidData?.maximumPossibleBidAmount) {
    //         const error = `Oops! Max bid amount is $ ${getFormatPrice(
    //             autoBidData?.maximumPossibleBidAmount
    //         )}`;

    //         setAutoBidValidationError(error);
    //     } else if (
    //         autoBidData?.activeBidRefinementEnabled === "Y" &&
    //         cleanAmount(amnt) > autoBidData?.lowerThresholdAmount
    //     ) {
    //         const error = `The maximum possible autobid limit is ${getFormatPrice(
    //             autoBidData?.activeBidRefinementEnabled
    //         )}`;
    //         setAutoBidValidationError(error);
    //     } else if (cleanAmount(amnt) < parseFloat(bidAmount)) {
    //         console.log('amnt ->', amnt);
    //         console.log('autoBidData?.bidAmountDetail?.bidAmount ->', autoBidData?.bidAmountDetail?.bidAmount)

    //         setAutoBidValidationError(`Limit must exceed current bid ${formatCurrency(bidAmount)}`);
    //     } else {

    //         const CHB =
    //             parseInt(autoBidData?.bidAmountDetail?.bidAmount) - parseInt(autoBidAmount?.currentHighestBidAmount + (autoBidAmount?.biddingIncrementalAmount ? autoBidAmount?.biddingIncrementalAmount : 1000));

    //             console.log('CHB ', CHB);
    //             console.log('autoBidAmount?.bidAmount ', autoBidAmount?.bidAmount);
    //         if ((parseInt(amnt) - parseInt(CHB)) % (autoBidAmount?.biddingIncrementalAmount ?  autoBidAmount?.biddingIncrementalAmount : 1000) != 0 ){
    //             const error =
    //                 "Please use $" +
    //                 currencyFormatNew(autoBidAmount?.biddingIncrementalAmount ? autoBidAmount?.biddingIncrementalAmount : 1000) +
    //                 " increments";

    //             setAutoBidValidationError(error);
    //         }
    //         else {
    //             setAutoBidValidationError("");

    //         }
    //     }


    // };



    const validateAutobidAmount = (autobidAmnt) => {


        const amnt = autobidAmnt ? autobidAmnt : autoBidAmount;
        // const CHB = autoBidData?.minimumBidIncrement;

        const minBidMnt = parseInt(autoBidData?.bidAmountDetail?.currentHighestBidAmount) + parseInt(autoBidData?.minimumBidIncrement);

        const CHB = Number(parseInt(autoBidData?.bidAmountDetail?.currentHighestBidAmount) - Number(autoBidData?.minimumBidIncrement));
        const bidAmount = Number(amnt);
        const increment = Number(autoBidData?.minimumBidIncrement);

        if (parseInt(bidAmount - CHB) % increment !== 0) {
            const error = `Please use $${currencyFormatNew(increment)} increments`;
            setAutoBidValidationError(error);
        }

        else if (autoBidData.activeBidRefinementEnabled && cleanAmount(amnt) > autoBidData?.lowerThresholdAmount) {
            const error = `You can set an auto bid of up to $${getFormatPrice(autoBidData?.lowerThresholdAmount)}`

            setAutoBidValidationError(error)

        }
        if (
            autoBidData.activeBidRefinementEnabled &&
            parseInt(cleanAmount(amnt)) >=
            parseInt(
                autoBidData?.lowerThresholdAmount +
                (autoBidData?.maximumBidAmount % autoBidData?.minimumBidIncrement) +
                autoBidData?.minimumBidIncrement
            ) &&
            nextPossibleBidAmount <=
            autoBidData?.lowerThresholdAmount +
            (autoBidData?.maximumBidAmount % autoBidData?.minimumBidIncrement)

            // cleanAmount(amnt) >
            // parseFloat(
            //   bidPageDetail?.currentBidAmountDetail
            //     ?.autoBidLimitForActiveBidRefinement
            // )
        ) {
            const error = ` The maximum possible autobid limit is ${getFormatPrice(
                autoBidData?.lowerThresholdAmount +
                (autoBidData?.maximumBidAmount % autoBidData?.minimumBidIncrement)
            )}`;
            setAutoBidValidationError(error);
        }
        else if (cleanAmount(amnt) > parseInt(autoBidData?.maximumBidAmount)) {
            const error = `Oops! Max bid amount is  $${getFormatPrice(autoBidData?.maximumBidAmount)}`
            setAutoBidValidationError(error)
        }

        else if (cleanAmount(amnt) < parseFloat(minBidMnt)) {
            const error = `Oops! Minimum bid amount is  $${getFormatPrice(minBidMnt)}`
            setAutoBidValidationError(error)
        }
        
        else {


            if (parseInt(bidAmount - CHB) % increment !== 0) {
                const error = `Please use $${currencyFormatNew(increment)} increments`;
                setAutoBidValidationError(error);
            }
            else {
                setAutoBidValidationError("");
            }

        }
    }

    const handleIncrement = () => {


        setAutoBidValidationError('');


        if (autoBidData?.activeBidRefinementEnabled) {

            if (parseFloat(cleanAmount(autoBidAmount)) < parseInt(autoBidData?.lowerThresholdAmount)) {
                const newAmnt = parseFloat(cleanAmount(autoBidAmount)) + autoBidData?.minimumBidIncrement;
                setAutoBidAmount(newAmnt);
                validateAutobidAmount(newAmnt);
                getAmountDetailsData(newAmnt);
            }

        } else {
            if (cleanAmount(autoBidAmount) > autoBidData?.maximumBidAmount) {
                setAutoBidAmount(autoBidData?.bidAmountDetail?.bidAmount);
                validateAutobidAmount(autoBidData?.bidAmountDetail?.bidAmount);
                getAmountDetailsData(autoBidData?.bidAmountDetail?.bidAmount);
                return;
            } else {
                const newAmnt = parseFloat(cleanAmount(autoBidAmount)) + autoBidData?.minimumBidIncrement;
                setAutoBidAmount(newAmnt);
                validateAutobidAmount(newAmnt);
                getAmountDetailsData(newAmnt);

            }

        }


    };



    // const getAmountDetailsData = (e) => {
    //     setAutoBidAmount(cleanAmount(e.target.value));
    //     validateAutobidAmount(cleanAmount(e.target.value));
    // }

    const getAmountDetailsData = async (value) => {
        const amnt = cleanAmount(value);
        setAutoBidAmount(cleanAmount(value));

        const res = await getBuyersPremiumDetail({
            listingId: listingId,
            bidAmount:
                amnt,
        });

        if (res) {
            console.log('res?.buyerPremium', res?.buyerPremium);

            setBuyerFeeFormatted(res?.buyerPremiumFormatted);
            setBuyerPremiumPercent(res?.percentageFormatted)

        }



        validateAutobidAmount(cleanAmount(value));
        // validateBidMinMaxPrice();
    };

    return (

        <Modal show={show} onHide={handleClose} size="md" className=''>
            <Modal.Header closeButton className="border-bottom py-3 add-agent-license">
                <Modal.Title className="p-1 mb-0 add-agent-license-title roboto-regular">Auto Bid Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className=' pt20'>
                    <Row xs={12} md={12}>
                        <Col xs={4} md={4}>
                            <p xs={6} md={6} className="" >Your Bid Amount  </p>
                        </Col>
                        <Col xs={8} md={8}>
                            <p xs={6} md={6} className="" >${getFormatPrice(bidAmount)}</p>
                        </Col>
                    </Row>




                    <div className="seperatorAutoBid prpl20"></div>


                    <Row xs={12} md={12}>
                        <Col xs={4} md={4}>
                            <p xs={6} md={6} className="pt12" >Auto Bid Limit  </p>
                        </Col>
                        <Col xs={8} md={8}>
                            <div xs={6} md={6}
                                className="col-md-3"
                                style={{
                                    width: "80px",
                                }}
                            >
                                <div
                                    className="d-flex align-items-center justify-content-around "
                                    style={{
                                        // border: "2px solid green",
                                    }}
                                >
                                    <button
                                        type=""
                                        className="autoBidDecBtn"
                                        data-bs-toggle=""
                                        onClick={() => {
                                            { handleDecrement() }
                                        }}>

                                        -
                                    </button>
                                    <input style={{ width: 120, height: 40 }}
                                        type="numeric"
                                        className="autoBidAmountInput"
                                        id=""
                                        // defaultValue={autoBidData?.bidAmountDetail?.bidAmountFormatted}
                                        value={'$' + getFormatPrice(autoBidAmount)}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            getAmountDetailsData(value);

                                        }}

                                    />
                                    <button

                                        type=""
                                        className="autoBidIncBtn"
                                        data-bs-toggle=""
                                        onClick={() => {
                                            handleIncrement()
                                        }}>


                                        +
                                    </button>
                                </div>
                            </div>
                            <p className='autobid-error-msg'>{autoBidValidationError}</p>
                        </Col>
                    </Row>


                </div>

                <div className="seperatorAutoBid prpl20">


                </div>
                {
                    shouldShowBuyerPremium &&

                    <><Row xs={12} md={12}>
                        <Col xs={4} md={4}>
                            <p xs={6} md={6} className="">
                                {propertyCategory === "8"
                                    ? buyerPremiumPercent != null
                                        ? `Transaction Fee (${buyerPremiumPercent})`
                                        : "Transaction Fee"
                                    : buyerPremiumPercent != null
                                        ? `Maximum Buyer's Premium (${buyerPremiumPercent})`
                                        : "Maximum Buyer's Premium"}</p>

                            {/* Maximum Buyer's Premium {(buyerPremiumPercent !== null && buyerPremiumPercent?.length !== 0 && buyerPremiumPercent !== undefined) ? "(" + buyerPremiumPercent + ")" : ""}</p> */}
                        </Col>
                        <Col xs={8} md={8}>
                            <p xs={6} md={6} className="">{buyerFeeFormatted}</p>
                        </Col>
                    </Row><div className="seperatorAutoBid prpl20">


                        </div></>
                }


                <div className='mt-4 d-flex justify-content-center'>

                    <button
                        type="button"
                        className="btn hubzu-btn-thm mr20"
                        onClick={handleAutoBidSave}

                    >
                        {isLoading ? (
                            <LoadingText text="Saving" />
                        ) : (
                            <LoadedText text="Save" />
                        )}
                    </button>


                    <button onClick={handleClose} className="autobid-close-btn">
                        Close
                    </button>

                </div>



            </Modal.Body>
        </Modal>
    );
};

export default AutoBidModal;
